export const normalizeAttendeeId = (attendeeId) => (attendeeId || '').replace(/#.*$/, '');

export const normalizeName = (rawName) => {
  const value = `${rawName || ''}`.trim();
  if (!value) {
    return '';
  }

  const hashParts = value.split('#').filter(Boolean);
  if (hashParts.length > 1) {
    const tail = hashParts[hashParts.length - 1].trim();
    if (/[A-Za-z]/.test(tail)) {
      return tail;
    }
  }

  return value;
};

export const getInitials = (name, fallback = 'U') => (
  (name || '')
    .split(' ')
    .filter(Boolean)
    .map((part) => part[0])
    .join('')
    .toUpperCase()
    .slice(0, 2) || fallback
);

export const getUserDisplayName = (user) => {
  if (!user) {
    return '';
  }

  return user.fullName || user.name || '';
};

export const buildJoinedAttendeeSet = (roster) => new Set(
  Object.keys(roster || {})
    .map((attendeeId) => normalizeAttendeeId(attendeeId))
    .filter(Boolean),
);

export const isJoinedUser = (user, joinedAttendeeIds) => {
  if (!user) {
    return false;
  }

  if (user.self) {
    return true;
  }

  const candidateIds = [
    user.participantId,
    user.attendeeId,
    user.userId,
    user.externalUserId,
    user.id,
  ].map((value) => normalizeAttendeeId(value)).filter(Boolean);

  return candidateIds.some((candidateId) => joinedAttendeeIds.has(candidateId));
};

export const resolveNameFromUsersByAttendeeId = (users, attendeeId) => {
  const normalized = normalizeAttendeeId(attendeeId);
  if (!normalized) {
    return '';
  }

  const match = (users || []).find((user) => {
    const participantId = normalizeAttendeeId(user?.participantId);
    const attendeeIdValue = normalizeAttendeeId(user?.attendeeId);
    const externalId = normalizeAttendeeId(user?.externalUserId);
    const userId = normalizeAttendeeId(user?.userId);
    const id = normalizeAttendeeId(user?.id);
    return participantId === normalized
      || attendeeIdValue === normalized
      || externalId === normalized
      || userId === normalized
      || id === normalized;
  });

  if (!match) {
    return '';
  }

  return match.fullName || match.name || '';
};
